import configuration from '../../utilities/configuration';
import * as EffectUtility from "../../utilities/EffectUtility";
import { BaseModel } from 'sjs-base-model';
import InformationProductModel from '../../models/contract/InformationProductModel';
import ContractTypeModel from "../../models/contract/ContractTypeModel";
import ContractModel from '../../models/contract/ContractModel';
import RelationModel from '../../models/contract/RelationModel';

// contract types
export async function requestAllContractTypes() {
    const endpoint = configuration.apiServer + configuration.apiContractTypesPath;
    return EffectUtility.getToModel(ContractTypeModel, endpoint);
}

export async function addContractType(type) {
    const endpoint = configuration.apiServer + configuration.apiContractTypesPath;
    return EffectUtility.postToModel(BaseModel, endpoint, type, true, true);
}

export async function updateContractType(id, type) {
    const endpoint = configuration.apiServer + configuration.apiContractTypesPath + "/" + id;
    return EffectUtility.putToModel(BaseModel, endpoint, type, true, true);
}

// information products
export async function requestAllInformationProducts() {
    const endpoint = configuration.apiServer + configuration.apiInformationProductsPath;
    return EffectUtility.getToModel(InformationProductModel, endpoint);
}

export async function addInformationProduct(product) {
    const endpoint = configuration.apiServer + configuration.apiInformationProductsPath;
    return EffectUtility.postToModel(BaseModel, endpoint, product, true, true);
}

export async function updateInformationProduct(id, product) {
    const endpoint = configuration.apiServer + configuration.apiInformationProductsPath + "/" + id;
    return EffectUtility.putToModel(BaseModel, endpoint, product, true, true);
}

// contracts
export async function requestAllContracts() {
    const endpoint = configuration.apiServer + configuration.apiContractsPath;
    return EffectUtility.getToModel(ContractModel, endpoint);
}

export async function addContract(contract) {
    const endpoint = configuration.apiServer + configuration.apiContractsPath;
    return EffectUtility.postToModel(BaseModel, endpoint, contract, true, true);
}

export async function updateContract(id, contract) {
    const endpoint = configuration.apiServer + configuration.apiContractsPath + "/" + id;
    return EffectUtility.putToModel(BaseModel, endpoint, contract, true, true);
}

// information product vs. subscriptionType relations
export async function requestAllRelations() {
    const endpoint = configuration.apiServer + configuration.apiProductsVsSubscriptionTypesPath;
    return EffectUtility.getToModel(RelationModel, endpoint);
}

export async function addRelation(relation) {
    const endpoint = configuration.apiServer + configuration.apiProductsVsSubscriptionTypesPath;
    return EffectUtility.postToModel(BaseModel, endpoint, relation, true, true);
}

export async function updateRelation(id, relation) {
    const endpoint = configuration.apiServer + configuration.apiProductsVsSubscriptionTypesPath + "/" + id;
    return EffectUtility.putToModel(BaseModel, endpoint, relation, true, true);
}

export async function deleteRelation(id) {
    const endpoint = configuration.apiServer + configuration.apiProductsVsSubscriptionTypesPath + "/" + id;
    return EffectUtility.deleteToModel(BaseModel, endpoint);
}

